/* GOLDENAGE rails: one behaviour for every horizontal row on the storefront.
 *
 * David, 2026-10-02: "the carusel on golden on destkop still dosent scrool its only if a drag and
 * drop only works inbetweeen the product castds not when i click and drag on the products fix it
 * and use like the carousel from out other brands it works there".
 *
 * Why it only worked in the gaps: pressing on a product photo or a product link starts the
 * browser's OWN image/link drag (the ghost picture you drop into another window). That native drag
 * takes the pointer away and fires pointercancel, so this script's drag died the instant it began.
 * In the gaps between cards there is no image and no link, nothing native starts, and the drag
 * worked. The old code did call preventDefault on dragstart, but only once it had already decided
 * a drag was running, and dragstart fires BEFORE the 5 px threshold is crossed, so the guard was
 * always too late.
 *
 * The fix is Park Friends' (assets/pf-dragscroll.js, the rail David says works): kill dragstart at
 * the document, in the capture phase, for anything inside a rail, unconditionally. The rest of
 * that script is ported with it:
 *
 *   - pointer events with setPointerCapture, so the drag survives leaving the row
 *   - a 5 px threshold before a press counts as a drag, so a plain click still opens the product
 *   - the click that ends a drag is swallowed once, in the capture phase
 *   - scrollLeft is written once per frame from requestAnimationFrame, not on every pointermove
 *     (moves fire several times a frame and every write forces a mid-frame reconcile, which is
 *     what made the row feel steppy)
 *   - momentum on release, with the velocity smoothed so one jittery sample cannot throw it
 *   - scroll snap switched off mid drag so the row follows the cursor exactly, back on to settle
 *   - cursor grab, then grabbing
 *   - a left and a right arrow that show only while there is more row that way
 *
 * Bind a row by giving it [data-ga-rail-track], or let the auto scan below pick up the rows this
 * theme already has. Rows that are built by script (the drawer upsell, the two product page
 * recommendation rows) call window.gaRail.scan() after they write their markup.
 */
(function () {
  if (window.gaRail) return;

  var SELECTORS = [
    '[data-ga-rail-track]',
    '.ga-rail__track',
    '.ga-details__track',
    '.cart-drawer-upsell__row',
  ];

  var THRESHOLD = 5;   /* px of movement before a press counts as a drag */
  var FRICTION = 0.94; /* per frame decay of the release glide */
  var MIN_GLIDE = 0.4; /* px/frame below which the glide stops */

  /* ---- the actual fix, and it has to be global and capture phase ----
     A press that lands on a product photo or a product link must not start the browser's native
     image/link drag, or the pointer stream is cancelled before this script ever sees a move. */
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.ga-railx, [data-ga-rail-track], .ga-rail__track, .ga-details__track, .cart-drawer-upsell__row')) {
      e.preventDefault();
    }
  }, true);

  function canScroll(track) {
    return track.scrollWidth - track.clientWidth > 2;
  }

  /* one card's worth of travel, so an arrow click lands on a card edge the snap agrees with */
  function stepOf(track) {
    var first = track.firstElementChild;
    if (!first) return Math.round(track.clientWidth * 0.8);
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    var w = first.getBoundingClientRect().width + gap;
    if (w < 40) return Math.round(track.clientWidth * 0.8);
    /* a card narrower than a third of the row moves two at a time, so the arrow is worth pressing */
    var per = w * 3 < track.clientWidth ? 2 : 1;
    return Math.round(w * per);
  }

  function bind(track) {
    if (!track || track.__gaRail) return;
    track.__gaRail = true;

    var wrap = track.parentNode;
    if (!wrap || !wrap.classList.contains('ga-railx')) {
      wrap = document.createElement('div');
      wrap.className = 'ga-railx';
      track.parentNode.insertBefore(wrap, track);
      wrap.appendChild(track);
    }

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'ga-railx__arrow ga-railx__arrow--prev';
    next.className = 'ga-railx__arrow ga-railx__arrow--next';
    prev.setAttribute('aria-label', 'Scroll left');
    next.setAttribute('aria-label', 'Scroll right');
    prev.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    next.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function paint() {
      var room = canScroll(track);
      var left = track.scrollLeft > 4;
      var right = room && track.scrollLeft < track.scrollWidth - track.clientWidth - 4;
      wrap.classList.toggle('is-scrollable', room);
      prev.classList.toggle('is-on', room && left);
      next.classList.toggle('is-on', room && right);
      prev.disabled = !left;
      next.disabled = !right;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -stepOf(track), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: stepOf(track), behavior: 'smooth' }); });
    track.addEventListener('scroll', paint, { passive: true });

    /* ---- press and drag, mouse only (a finger already has native scrolling) ---- */
    var down = false, moved = false, startX = 0, startScroll = 0, target = 0;
    var lastX = 0, lastT = 0, velocity = 0, frame = null;

    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    function apply() {
      frame = null;
      var max = maxScroll();
      if (target < 0) target = 0;
      if (target > max) target = max;
      track.scrollLeft = target;
    }

    function schedule() {
      if (frame === null) frame = requestAnimationFrame(apply);
    }

    function settle() {
      track.style.scrollSnapType = '';
      track.classList.remove('is-dragging');
    }

    function glide() {
      velocity *= FRICTION;
      if (Math.abs(velocity) < MIN_GLIDE) { settle(); return; }
      var max = maxScroll();
      target += velocity;
      if (target <= 0 || target >= max) {
        target = target <= 0 ? 0 : max;
        track.scrollLeft = target;
        settle();
        return;
      }
      track.scrollLeft = target;
      requestAnimationFrame(glide);
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      /* a control inside a card keeps its own press (size pill, quick add, quantity) */
      if (e.target.closest('button, input, select, textarea')) return;
      down = true;
      moved = false;
      startX = lastX = e.clientX;
      startScroll = target = track.scrollLeft;
      lastT = e.timeStamp;
      velocity = 0;
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < THRESHOLD) return;

      if (!moved) {
        moved = true;
        track.classList.add('is-dragging');
        /* snap fights a drag: the row would jump back to the nearest card on every frame */
        track.style.scrollSnapType = 'none';
        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }

      target = startScroll - dx;
      schedule();

      var dt = e.timeStamp - lastT;
      if (dt > 0) {
        /* smoothed, so one jittery sample cannot throw the glide */
        var vx = (lastX - e.clientX) / dt;
        velocity = velocity * 0.7 + vx * 0.3;
        lastX = e.clientX;
        lastT = e.timeStamp;
      }
      e.preventDefault();
    });

    function end(e) {
      if (!down) return;
      down = false;
      if (track.releasePointerCapture && e && e.pointerId != null) {
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      if (!moved) return;
      moved = false;

      /* eat the click this drag is about to fire, so letting go on a card does not open it */
      track.addEventListener('click', function (click) {
        click.preventDefault();
        click.stopPropagation();
      }, { capture: true, once: true });

      velocity = velocity * 16; /* px/ms to px/frame at 60fps */
      if (Math.abs(velocity) < MIN_GLIDE) { settle(); return; }
      requestAnimationFrame(glide);
    }

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    paint();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(paint);
      ro.observe(track);
      if (track.firstElementChild) ro.observe(track.firstElementChild);
    } else {
      window.addEventListener('resize', paint);
    }
    /* images land after the first paint and change the row width */
    track.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', paint); });
    window.addEventListener('load', paint);
  }

  function scan(root) {
    var where = root || document;
    SELECTORS.forEach(function (sel) {
      where.querySelectorAll(sel).forEach(bind);
    });
  }

  window.gaRail = { bind: bind, scan: scan };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* the cart drawer and the two recommendation rows replace their markup after load; the drawer
     rail is also 0 wide until the drawer opens, so a rescan on any DOM change keeps it bound */
  if (window.MutationObserver) {
    new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
